import { css } from 'styled-components';
export default {
    openSans: {
        light: css `
      font-family: 'Open Sans', sans-serif;
      font-style: normal;
      font-weight: 400;
    `,
        lightItalic: css `
      font-family: 'Open Sans', sans-serif;
      font-weight: 400;
      font-style: italic;
    `,
        extraBold: css `
      font-family: 'Open Sans', sans-serif;
      font-style: normal;
      font-weight: 800;
    `,
        extraBoldItalic: css `
      font-family: 'Open Sans', sans-serif;
      font-weight: 800;
      font-style: italic;
    `,
    },
    ubuntu: {
        medium: css `
      font-family: 'Ubuntu', serif;
      font-style: normal;
      font-weight: 500;
    `,
        bold: css `
      font-family: 'Ubuntu', serif;
      font-style: normal;
      font-weight: 700;
    `,
    },
};
